module.exports = __webpack_public_path__ + "static/media/icon-arrow.794c5a48.svg";